type AppMode = 'tg' | 'web'

const mode = (import.meta.env.VITE_APP_MODE ?? 'tg') as AppMode

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL ?? ''

/**
 * Запасной бэкенд на случай, когда основной недоступен: у части людей он
 * закрыт по географии. Не задан или совпадает с основным — переключение
 * выключено целиком (так живут тест и локальная разработка).
 */
const fallbackApiBaseUrl = import.meta.env.VITE_FALLBACK_API_BASE_URL ?? ''

export const ENV = {
  APP_MODE: mode,
  IS_TG: mode === 'tg',
  IS_WEB: mode === 'web',
  API_BASE_URL: apiBaseUrl,
  FALLBACK_API_BASE_URL:
    fallbackApiBaseUrl && fallbackApiBaseUrl !== apiBaseUrl
      ? fallbackApiBaseUrl
      : '',
  IS_DEV: import.meta.env.DEV,
  IS_PROD: import.meta.env.PROD,
} as const
